import { isPluginTab, TabInfo } from 'editor/src/store/editorModules/sidebar/types';
import { PluginName } from 'editor/src/store/plugins/types';

const isPluginEnabled = (pluginName: PluginName, activeTab: TabInfo) =>
  isPluginTab(activeTab) && activeTab.plugin === pluginName;

export default isPluginEnabled;
